import React from 'react';
import { Loader2 } from 'lucide-react';
import { BTN, C, FONT_UI } from '../../constants/design-tokens';

export type TextBtnVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export const TextBtn = ({
  onClick,
  label,
  icon,
  variant = 'ghost',
  disabled = false,
  loading = false,
  fullWidth = false
}: {
  onClick: () => void;
  label: string;
  icon?: React.ReactNode;
  variant?: TextBtnVariant;
  disabled?: boolean;
  loading?: boolean;
  /** Si true, el botón estira a 100% del contenedor (default: auto). */
  fullWidth?: boolean;
}) => {
  const styles: Record<TextBtnVariant, React.CSSProperties> = {
    primary: {
      background: BTN.primary.bg,
      border: 'none',
      color: BTN.primary.text,
      fontWeight: 600,
      fontFamily: FONT_UI
    },

    secondary: {
      background: BTN.secondary.bg,
      border: 'none',
      color: BTN.secondary.text,
      fontWeight: 600,
      fontFamily: FONT_UI
    },

    ghost: {
      background: BTN.ghost.bg,
      border: 'none',
      color: BTN.ghost.text,
      fontWeight: 400,
      fontFamily: FONT_UI
    },

    danger: {
      background: C.dangerSurface,
      border: `1px solid ${C.dangerBorder}`,
      color: C.danger,
      fontFamily: FONT_UI
    }
  };

  const isDisabled = disabled || loading;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      style={{
        height: '36px',
        width: fullWidth ? '100%' : 'auto',
        padding: '0 14px',
        borderRadius: '8px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        fontSize: '13px',
        fontFamily: FONT_UI,
        fontWeight: 600,
        letterSpacing: '0.01em',
        opacity: isDisabled ? 0.5 : 1,
        ...styles[variant]
      }}
    >
      {loading ? <Loader2 size={14} style={{ animation: 'spin 1s linear infinite' }} /> : icon}
      <span style={{ whiteSpace: 'nowrap' }}>{label}</span>
    </button>
  );
};
